export default __webpack_public_path__ + "static/media/ic_polygon_40.cfb5d9ed.png";